import * as _ from "lodash";
import { OnboardingRepo } from "@services/onboarding.repo";
import { FileItems } from "@app/onboarding/FileItems";
import { ClientRepo } from "@services/clients/client.repo";
import { extractErrorMessage } from "@common/utils/errorUtils";

class clientApplicationController implements angular.IOnInit {
  public files: FileItems[];
  public currentInput: any;
  private fileControl: HTMLInputElement;
  public clients: string[];
  public isClientLoading = true;
  public isFileLoading = true;

  /** @ngInject */
  constructor(
    private onboardingRepo: OnboardingRepo,
    private clientRepo: ClientRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any,
    private $window: angular.IWindowService,
    private $rootScope: angular.IRootScopeService,
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit() {
    this.loadFileData();
    this.loadClientData();
    this.fileControl = document.getElementById(
      "uploadFile"
    ) as HTMLInputElement;
    this.fileControl.addEventListener(
      "change",
      this.uploadFileEventChange.bind(this)
    );
  }

  loadFileData() {
    this.isFileLoading = true;
    this.files = [];
    this.onboardingRepo
      .getFiles()
      .then((files) => {
        this.files = files;
        this.isFileLoading = false;
      })
      .catch((err) => this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`));
  }

  loadClientData() {
    this.isClientLoading = true;
    this.clients = [];
    this.onboardingRepo
      .getClients()
      .then((clients) => {
        this.clients = clients;
        this.isClientLoading = false;
      })
      .catch((err) => this.notifyjs(`Failed to retrieve clients: ${extractErrorMessage(err)}`));
  }

  getFileName(file) {
    return file.key.split("accountForms/")[1];
  }

  downloadFileUrl(file) {
    this.$window.open(file.url, "_blank");
  }

  openFile() {
    document.getElementById("uploadFile").click();
  }

  deleteFile(file) {
    this.onboardingRepo.deleteFile(file.key).then(() => {
      this.loadFileData();
    });
  }

  uploadFileEventChange(event) {
    this.isFileLoading = true;
    let file = event.target.files[0];
    this.onboardingRepo
      .uploadFile(file)
      .then((res) => {
        // console.log(res);
        this.loadFileData();
      })
      .catch((err) => this.notifyjs(`Failed to upload file: ${extractErrorMessage(err)}`));
  }

  viewClient(client) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.client = client;
    return this.$mdDialog.show({
      template:
        '<client-info-modal selected-client="client"></client-info-modal>',
      scope: tempScope,
    });

    // this.$state.go("root.clientapplication.details", { client: client });
  }
}

export const clientApplication: angular.IComponentOptions = {
  template: require("./clientApplication.html"),
  controller: clientApplicationController,
};



// WEBPACK FOOTER //
// ./src/app/onboarding/clientApplication.ts